import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://cccs.cordonnx.com/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;


// Add FCR Report API functions
export const fcrReportApi = {
  // Create FCR report for a vehicle
  create: (vehicleId, data) => 
    api.post(`/fcr-reports/vehicle/${vehicleId}`, data),
  
  // Get FCR report by vehicle ID
  getByVehicle: (vehicleId) => 
    api.get(`/fcr-reports/vehicle/${vehicleId}`),

   getByVehicleNumber: (vehicleNumber) => 
    api.get(`/fcr-reports/vehicle-number/${encodeURIComponent(vehicleNumber)}`),
  
  // Get all FCR reports with filters
  getAll: (params) => 
    api.get('/fcr-reports', { params }),
  
  // Update FCR report
  update: (id, data) => 
    api.put(`/fcr-reports/${id}`, data),
  
  // Delete FCR report
  delete: (id) => 
    api.delete(`/fcr-reports/${id}`)
};